<template>
    <div :class="prefixCls">
        <div :class="`${prefixCls}-fixed`">
            <div :class="`${prefixCls}-fixed-clear`">
                <span :class="`${prefixCls}fixed-limit`">
                    {{t('selectMember.selected')}}（{{getSelectedCount()}}/{{limit}}）
                </span>
                <span :class="`${prefixCls}-fixed-btn`" @click="handleClear">
                    {{t('selectMember.clear')}}
                </span>
            </div>
        </div>
        <div :class="`scroll-content-horizonal ${prefixCls}-content`"  ref="scrollContent">
            <template v-for="(data, key) in selected">
                <Collapse v-if="Object.keys(data).length"
                    :key="key"
                    :title="tabs[key]">
                    <template slot="title">
                        {{tabs[key]}}
                    </template>
                    <template slot="content">
                        <div :class="`${prefixCls}-item`"
                            v-for="(item, index) in data"
                            :key="index">
                            <div :class="`${prefixCls}-item-member`" v-if="item.type === 0">
                                <Avatar 
                                    size="32px"
                                    fontSize="12px"
                                    :name="item.userName || item.name"
                                    :memberId="item.memberId"
                                    :path="item.avatar"/>
                                <div :class="`${prefixCls}-item-member-info`">
                                    <div :class="`${prefixCls}-item-member-name`">{{item.userName || item.name}}</div>
                                    <div :class="`${prefixCls}-item-member-dept`">{{item.deptName}}</div>
                                </div>
                            </div>
                            <div v-if="item.type === 1">{{item.deptName}}</div>
                            <div v-if="item.type === 3">{{item.groupName}}</div>
                            <div v-if="item.type === 4">{{item.teamName}}</div>
                            <i :class="`${prefixCls}-item-remove`" @click="handleSelected(item)">
                                <Icon type="cross"/>
                            </i>
                        </div>
                    </template>
                </Collapse>
            </template>
        </div>
    </div>
</template>
<script>
    import Icon from '../../base/icon/'
    import Avatar from '../../base/avatar/'
    import Collapse from '../../base/collapse/'
    import scroll from './mixins/scroll'
    import Locale from '../../../mixins/locale'
    import { t } from '../../../locale/'

    const prefixCls = 'yy-select-member-selected'
    export default {
        name: 'Selected',
        mixins: [scroll, Locale],
        inject: ['root'],
        props: {
            selected: {
                type: Object
            },
            limit: {
                type: Number
            },
        },
        data() {
            return {
                tabs: {
                    dept: t('selectMember.dept'),
                    group: t('selectMember.group'),
                    team: t('selectMember.team'),
                    member: t('selectMember.member')
                },
                prefixCls: prefixCls
            }
        },
        components: {
            Icon,
            Avatar,
            Collapse
        },
        methods: {
            getSelectedCount() {
                const selected = this.selected
                let count = 0
                Object.keys(selected).forEach((key)=>{
                    count += Object.keys(selected[key]).length
                })
                return count
            },
            handleSelected(data) {
                data.checked = false
                this.$emit('handleSelected', data)
            },
            handleClear() {
                this.root.handleClear()
                this.updateScroll()
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/business/select-member/selected.vue